import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CrudService} from '../../../services/crud.service';
import {LocalStorageService} from '../../../services/localStorage.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { debounceTime, Subject, takeUntil } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-public-playlist',
  templateUrl: './public-playlist.component.html',
  styleUrls: ['./public-playlist.component.css', '../new-my-group/new-my-group.component.css']
})
export class PublicPlaylistComponent implements OnInit {

  groupId: any = '';
  groupAllVideos = [];
  groupDetails: any;
  spinner: any = false;
  isLoggedIn = false;
  isEmbed: any;
  searchText: any = '';
  isLogo: boolean = false;
  defaultEditTabType: any;
  currentContentTab: any;
  groupAllTabsContent = [];
  private markVideoToRefresh = false;
  groupActiveTabContent = [];
  groupAllLinks: Array<any> = [];
  groupTabsContentSize = null;
  selectedBadge: any;
  addGroupShareVideoPage = 1;
  ownerVideos: Array<any> = [];
  ownerLinks: Array<any> = [];
  currentMemberTab = 'admin';
  currentAddVideoTab = 'admin';
  currentAddLinkTab = 'admin';
  contentTabs = [];
  isMoveContent: boolean = false;
  isMediaContent = false;
  isLinkMediaContent = false;
  isCalledContentInFunction: boolean = true;

  private _unsubscribeAll: Subject<any> = new Subject<any>();
  

  constructor(private crudService: CrudService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private dashboardService: DashboardService,
  ) {
      this.activeRoute.queryParams.subscribe(params => {
        if (params.embed && params.embed === 'true') {
          this.isEmbed = params?.embed;
        }
        if (params.noLogo && params.noLogo === 'true') {
          this.isLogo = params?.noLogo;
        }
        this.groupId = params.groupId;
        // console.log("this.groupId = ", this.groupId);
      });
    

    this.dashboardService.getSearchTerm
        .pipe(takeUntil(this._unsubscribeAll), debounceTime(1000))
        .subscribe((res) => {
          this.searchText = res;
            // if (this.searchText) {
            //   this.searchGroupBookmarkVectorIndex();
            // } else {
            //   this.getGroupContents();
          // }
          
          this.getGroupDetails();
          });
    
    }

  ngOnInit() {

    this.spinner = true;

    this.isLoggedIn = this.localStorageService.getItem('user') != null;

    if (!this.isLoggedIn) {
      this.crudService.getAnonymousUser().subscribe(success => {
        if (success) {
          this.localStorageService.setItem('anonymousToken', success.data.token);
          this.isLoggedIn = true;

          if(!this.groupId)
            this.router.navigate(['profile']);

          this.getGroupDetails();
          this.getGroupContents();
        }
      })
    } else {
      if(!this.groupId)
       this.router.navigate(['profile']);
  
      
      this.getGroupDetails();
      this.getGroupContents();
    }
  };

  initAll() {

    this.addGroupShareVideoPage = 1;
    this.ownerVideos = [];
    this.ownerLinks = [];
    this.currentAddVideoTab = 'admin';
    this.currentAddLinkTab = 'admin';
    this.currentMemberTab = 'admin';
    this.currentContentTab = 'videos';
    this.groupAllTabsContent = [];

    // console.log('initAll - groupId = ', this.groupId);
    // this.getAllUsers();
    // this.getCurrentUserInfo();

  }

  get isFixedCurrentContentTab() {
    return ['Videos', 'Links', undefined, null].includes(this.defaultEditTabType);
  }

  getGroupDetails() {
    this.groupDetails = [];
    this.groupAllVideos = [];
    this.groupAllLinks = [];
    this.spinner = true;
    this.crudService.getGroupDetail(this.groupId).subscribe(res => {
      this.groupDetails = res.data[0];
      //console.log("this.groupDetails = ", this.groupDetails);

      this.filterGroupDetailWithSpecialChat(this.groupDetails);
      this.groupDetails.thumbnailSetting = this.groupDetails?.thumbnailSetting ? this.groupDetails?.thumbnailSetting : 'contain'
      this.dashboardService.setGroupDetails = this.groupDetails;

      if (!this.groupDetails?.tabOrders?.length) {
        this.contentTabs = this.groupDetails?.userDefinedTabs || [];
        this.defaultEditTabType = 'Videos';
      }
      if (this.groupDetails?.tabOrders?.length) {
        this.contentTabs = this.groupDetails?.tabOrders || [];
        this.defaultEditTabType = 'userDefine';
      }

      this.isCalledContentInFunction = true;
      this.refreshAllGroupContent()

      if (!this.groupDetails) {
        this.router.navigate(['/']);
        return;
      }
    })
  }

  getGroupContents() {
    // console.log("getGroupContents");

    this.crudService.getGroupContentPlaylist(this.groupId, this.searchText, ).subscribe(success => {
      this.groupAllVideos = success.data;
      // console.log("this.groupAllVideos = ", this.groupAllVideos);

      this.spinner = false;
    })
  }

  // Show video
  showVideo(id: any) {
    this.router.navigate(['videos'], { queryParams: { video: id, groupId: this.groupId } });
  }

  searchGroupBookmarkVectorIndex() {
    this.spinner = true;

    this.crudService.searchGroupBookmarkVectorIndex({ groupId: this.groupId, userQuery: this.searchText }).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.groupAllVideos = res.data;

      this.spinner = false;
      // if (res.status) {
      //   this.groupVideos = res.data;
      // }
    })
  }

  clickRightArrow() {
    const scrollRight = document.getElementById("right-arrow");
    const scrollLeft = document.getElementById('left-arrow');
    const productListContainer = document.querySelector(".theme-scrollbar");
    // Function to check arrow visibility
    const checkIfEndReached = () => {
      // const maxScrollLeft = productListContainer.scrollWidth - productListContainer.clientWidth;
      // scrollRight.style.display = (productListContainer.scrollLeft >= maxScrollLeft) ? 'none' : 'block';
      // scrollLeft.style.display = (productListContainer.scrollLeft <= 0) ? 'none' : 'block';
    };

    // Click event for right arrow
    scrollRight.addEventListener('click', () => {
      const scrollAmount = productListContainer.clientWidth;
      const maxScrollLeft = productListContainer.scrollWidth - productListContainer.clientWidth;

      // Scroll right, ensuring not to exceed maxScrollLeft
      productListContainer.scrollBy({
        top: 0,
        left: Math.min(scrollAmount, maxScrollLeft - productListContainer.scrollLeft),
        behavior: 'smooth'
      });

      setTimeout(checkIfEndReached, 500); // Check after scroll animation completes
    });

    // Click event for left arrow
    scrollLeft.addEventListener('click', () => {
      const scrollAmount = productListContainer.clientWidth;

      // Scroll left, ensuring not to go below 0
      productListContainer.scrollBy({
        top: 0,
        left: -Math.min(scrollAmount, productListContainer.scrollLeft),
        behavior: 'smooth'
      });

      setTimeout(checkIfEndReached, 500); // Check after scroll animation completes
    });

    // Check arrows visibility on scroll and initial load
    productListContainer.addEventListener('scroll', checkIfEndReached);

    // Initial check to set arrows visibility
    checkIfEndReached();
  }


  getVideosTabName(): string {
    if (!this.groupDetails?.deletedDefaultTabs?.includes("Videos")) {
      if (this.groupDetails && this.groupDetails?.renamedDefaultTabs?.length) {
        const videosTab = this.groupDetails.renamedDefaultTabs?.find(tab => tab?.type === 'Videos');
        return videosTab ? videosTab?.name : 'Videos';
      } else {
        return 'Videos';
      }
    }
  }

  getLinksTabName(): string {
    if (!this.groupDetails?.deletedDefaultTabs?.includes("Links")) {
      if (this.groupDetails && this.groupDetails?.renamedDefaultTabs?.length) {
        const linksTab = this.groupDetails.renamedDefaultTabs?.find(tab => tab?.type === 'Links');
        return linksTab ? linksTab?.name : 'Links';
      } else {
        return 'Links';
      }
    }
  }


  onChangeContentTab(tab, type?) {

    if (type) {
      this.defaultEditTabType = type;
    }
    this.currentContentTab = tab;

    if (!this.isFixedCurrentContentTab) {

      const activeTab = this.groupAllTabsContent.find(x => x.name === tab);
      // if (activeTab) {
      //     this.groupActiveTabContent = activeTab.data;
      // } else {
      // if(!this.isMoveContent){
      this.getGroupContentByTabName(tab);
      // }
      // }
    } else {

      if (this.markVideoToRefresh) {
        this.markVideoToRefresh = false;
        // this.refreshAllGroupContent();
      }

      if (type === "Videos") {
        this.crudService.getGroupContent(this.groupId, '', this.searchText).subscribe((res) => {

          this.groupAllVideos = res.data;
          //console.log("groupAllVideos", this.groupAllVideos);
          // this.isMediaContent = false
        });

      }
    }
  }

  getGroupContentByTabName(tab) {
    this.spinner = true;
    this.crudService.getGroupContent(this.groupId, tab, this.searchText)
      .pipe(takeUntil(this._unsubscribeAll)).subscribe(success => {
        this.groupActiveTabContent = success.data;

        const activeTab = this.groupAllTabsContent.find(x => x.name === tab);

        if (activeTab) {
          activeTab.data = success.data
        } else {
          this.groupAllTabsContent.push({
            name: tab,
            data: success.data
          });

        }

      }).add(() => this.spinner = false);

    return this.groupAllTabsContent
  }

  openModalForBadge(tabName: any) {
    this.spinner = true;
    // this.currentContentTab = tabName;
    
    let badgeId;
    this.groupDetails?.tabsWithBadge?.map((i: any) => {
      if (i.name === tabName) {
        badgeId = i.badgeId
      }
    })
    this.crudService.getSpecificBadge(badgeId).subscribe((res: any) => {
      this.selectedBadge = res.data;
      this.spinner = false;
      $("#badgeUpdateDeleteModal").modal('show')
    })
  }

  isDisplayEdit(tabName: any) {
    return !this.groupDetails?.tabsWithBadge?.some((i) => i.name === tabName);
  }

  shouldShowTab(tab: any): boolean {
    if (!this.searchText) {
      return true;
    }

    const videoCount = Number(this.getCountOfVideos(tab.name)) || 0;

    const isUserDefineWithNoVideos = tab.type === 'userDefine' && videoCount === 0;
    const isVideosWithNoGroupVideos = tab.type === 'Videos' && (this.groupAllVideos?.length || 0) === 0;
    const isOthersWithNoGroupLinks =
      tab.type !== 'Videos' && tab.type !== 'userDefine' && (this.groupAllLinks?.length || 0) === 0;

    const result = !(isUserDefineWithNoVideos || isVideosWithNoGroupVideos || isOthersWithNoGroupLinks);
    return result;
  }

  getCountOfVideos(name: any) {
    let count;
    this.groupTabsContentSize?.map((i: any) => {

      if (name === i?.tabName) {
        count = i?.tabContentCount
      }
    })

    return count;
  }

  filterGroupDetailWithSpecialChat(groupDetail: any) {
    this.groupDetails.groupName = groupDetail?.groupName?.replace(/&amp;/g, '&');
    this.groupDetails.description = groupDetail?.description?.replace(/&amp;/g, '&');
    this.groupDetails.pageContentTitle = groupDetail?.pageContentTitle?.replace(/&amp;/g, '&');
    this.groupDetails.pageAdminTitle = groupDetail?.pageAdminTitle?.replace(/&amp;/g, '&');
  }

  refreshAllGroupContent() {
    if (!this.isMoveContent) {
      this.isMediaContent = !!this.groupAllVideos?.length;
      this.isLinkMediaContent = !!this.groupAllLinks?.length;
    }

    if (this.isCalledContentInFunction) {
      if (this.groupDetails?.tabOrders?.length) {
        this.currentContentTab = this.groupDetails?.tabOrders[0].name
        this.defaultEditTabType = this.groupDetails?.tabOrders[0].type
        this.getGroupContentByTabName(this.currentContentTab);

      } else {
        this.currentContentTab = this.getVideosTabName() ? this.getVideosTabName() : this.getLinksTabName() ? this.getLinksTabName() : this.groupDetails?.userDefinedTabs[0];

        this.getGroupContentByTabName(this.currentContentTab);
      }
    }


    if ((this.defaultEditTabType !== 'userDefine' && this.defaultEditTabType !== undefined) || this.groupDetails?.tabOrders?.length) {
      // if ((this.defaultEditTabType !== 'userDefine' && this.defaultEditTabType === undefined)) {

      this.spinner = true;
      this.crudService.getGroupContent(this.groupId, '', this.searchText)
        .pipe(takeUntil(this._unsubscribeAll)).subscribe(success => {
          this.groupAllVideos = success.data;
          this.isMediaContent = !!this.groupAllVideos?.length;
        }).add(() => this.spinner = false);

      this.crudService.getGroupLinkContent(this.groupId, this.searchText)
        .pipe(takeUntil(this._unsubscribeAll)).subscribe(success => {
          this.groupAllLinks = success.data;
          this.isLinkMediaContent = !!this.groupAllLinks?.length;
        }).add(() => this.spinner = false);


      this.crudService.getGroupContent(this.groupId, this.currentContentTab, this.searchText).subscribe((res) => {
        this.groupActiveTabContent = res.data;

        const activeTab = this.groupAllTabsContent.find(x => x.name === this.currentContentTab);

        if (activeTab) {
          activeTab.data = res.data
        } else {
          this.groupAllTabsContent.push({
            name: this.currentContentTab,
            data: res.data
          });

        }

      })
    } else {
      this.getGroupContentByTabName(this.currentContentTab);
    }

    //WC 02212024
    this.crudService.getGroupTabsContentSize(this.groupId, this.searchText)
      .pipe(takeUntil(this._unsubscribeAll)).subscribe(success => {
        this.groupTabsContentSize = success.data;
      }).add(() => this.spinner = false);

    //WC 02212024
  }

  gotoVideos(item: any) {
    let matchTab = item?.userDefinedTab === null ? this.currentContentTab : item?.userDefinedTab
    let isExistsInTabWithBadge = this.groupDetails?.tabsWithBadge?.some((i) => i.name === matchTab);
    let badgeId: any;
    let isDefaultTab = item?.userDefinedTab === null ? true : false

    this.groupDetails?.tabsWithBadge?.map((i) => {
      if (i.name === matchTab) {
        badgeId = i.badgeId
      }
    })

    this.router.navigate(['videos'], { queryParams: { video: item.videoId, groupId: this.groupId } });

    // if (isExistsInTabWithBadge) {
    //   this.router.navigate(['videos'], { queryParams: { video: item.videoId, embed: this.isEmbed, back: this.isEmbed, groupId: item?.groupId, tabName: this.currentContentTab, isDefaultTab: isDefaultTab, badgeId: badgeId } });
    // } else {
    //   this.router.navigate(['videos'], { queryParams: { video: item.videoId, embed: this.isEmbed, back: this.isEmbed, groupId: this.groupId } });
    // }
  }

  goToLink(link: any) {
    window.open(link, '_blank');
  }
}
